const PT = require("prop-types");
const React = require("react");
const StudentLink = require("./StudentLink");

const styles = require("./styles/Checkmark.css");
const colorStyles = require("./styles/Colors.css");

const Checkmark = function(props) {
	const {
		colorName = "yellow",
		size = "small",
		hidden = false,
		isOffice = false,
		linkTo = null,
	} = props;
	let {className = ""} = props;

	const colorClass = colorStyles[colorName + "Color"];
	className = [className, styles["checkmark-" + size], colorClass].join(" ");

	let node;

	if (hidden) {
		node = <div className={className} />;
	} else {
		if (isOffice) {
			node = (
				<svg
					version="1.1"
					id="Header_Buttons"
					xmlns="http://www.w3.org/2000/svg"
					x="0px"
					y="0px"
					viewBox="0 0 20 20"
					width="20"
					height="20"
					preserveAspectRatio="none"
					className={className}
				>
					<polygon points="7.1,17 1.8,11.6 3.6,9.9 6.9,13.2 15.2,2 17.2,3.5 " />
				</svg>
			);
		} else {
			node = (
				<svg
					version="1.1"
					id="Header_Buttons"
					xmlns="http://www.w3.org/2000/svg"
					x="0px"
					y="0px"
					viewBox="0 0 40 40"
					width="40"
					height="40"
					preserveAspectRatio="none"
					className={className}
				>
					<polygon points="30.5 3.73 36.58 9.77 15.34 36.03 3.34 25.38 8.76 19.34 14.77 27.79 30.5 3.73" />
				</svg>
			);
		}
	}

	if (linkTo) {
		node = (
			<StudentLink linkTo={linkTo} useWonkyCursor={true}>
				{node}
			</StudentLink>
		);
	}
	return node;
};

Checkmark.propTypes = {
	colorName: PT.string,
	size: PT.oneOf(["small", "medium", "large"]),
	className: PT.string,
	hidden: PT.bool,
	isOffice: PT.bool,
};

module.exports = Checkmark;
